import React from 'react'

interface TargetStoreProps {
  className?: string
}

const TargetStore: React.FC<TargetStoreProps> = ({
  className,
}: TargetStoreProps) => (
  <svg
    className={className}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_417_366)">
      <circle
        cx="10"
        cy="10"
        r="9.375"
        fill="white"
        stroke="white"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 13.3357C10.4381 13.3357 10.8718 13.2494 11.2765 13.0818C11.6812 12.9142 12.049 12.6685 12.3587 12.3587C12.6685 12.049 12.9142 11.6812 13.0818 11.2765C13.2494 10.8718 13.3357 10.4381 13.3357 10C13.3357 9.56195 13.2494 9.12819 13.0818 8.72348C12.9142 8.31877 12.6685 7.95104 12.3587 7.64129C12.049 7.33154 11.6812 7.08584 11.2765 6.9182C10.8718 6.75057 10.4381 6.66429 10 6.66429C9.11531 6.66429 8.26686 7.01573 7.64129 7.64129C7.01573 8.26686 6.66429 9.11531 6.66429 10C6.66429 10.8847 7.01573 11.7331 7.64129 12.3587C8.26686 12.9843 9.11531 13.3357 10 13.3357ZM20 10C20 12.6522 18.9464 15.1957 17.0711 17.0711C15.1957 18.9464 12.6522 20 10 20C7.34784 20 4.8043 18.9464 2.92893 17.0711C1.05357 15.1957 0 12.6522 0 10C0 7.34784 1.05357 4.8043 2.92893 2.92893C4.8043 1.05357 7.34784 0 10 0C12.6522 0 15.1957 1.05357 17.0711 2.92893C18.9464 4.8043 20 7.34784 20 10ZM16.6643 10C16.6643 11.7675 15.9622 13.4626 14.7124 14.7124C13.4626 15.9622 11.7675 16.6643 10 16.6643C8.23252 16.6643 6.53743 15.9622 5.28764 14.7124C4.03784 13.4626 3.33571 11.7675 3.33571 10C3.33571 8.23252 4.03784 6.53743 5.28764 5.28764C6.53743 4.03784 8.23252 3.33571 10 3.33571C11.7675 3.33571 13.4626 4.03784 14.7124 5.28764C15.9622 6.53743 16.6643 8.23252 16.6643 10Z"
        fill="#CC0000"
      />
    </g>
    <defs>
      <clipPath id="clip0_417_366">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
)

export default TargetStore
